import normalize, { userSchema } from 'schema';
import {
  CREATE_PARTIAL_USER,
  CREATE_PARTIAL_USER_SUCCESS,
  UPDATE_PARTIAL_USER,
  CREATE_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
} from 'actionTypes';

export function createPartialUser() {
  return {
    type: CREATE_PARTIAL_USER,
  };
}

export function createPartialUserSuccess(response) {
  return {
    type: CREATE_PARTIAL_USER_SUCCESS,
    normalizedData: normalize(response.payload, userSchema),
    token: response.payload.token,
  };
}

// Don't use these in components, they are "private"
export function updatePartialUser(userData) {
  return {
    type: UPDATE_PARTIAL_USER,
    payload: userData,
  };
}

export function createUser(userData) {
  return {
    type: CREATE_USER,
    payload: userData,
  };
}

export function registerUser(userData) {
  return {
    type: REGISTER_USER,
    payload: userData,
  };
}

export function registerUserSuccess(response) {
  return {
    type: REGISTER_USER_SUCCESS,
    normalizedData: normalize(response.payload, userSchema),
    token: response.payload.token,
  };
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js